module.exports = require("./fo-FO.js");